<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>项目管理
                    <i class="el-icon-lx-cascades"></i> 设备管理
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
                <el-button
                    type="primary"
                    icon="el-icon-delete"
                    class="handle-del mr10"
                    @click="delAllSelection"
                >批量删除</el-button>
                <!-- <el-select v-model="query.address" placeholder="地址" class="handle-select mr10">
                    <el-option key="1" label="广东省" value="广东省"></el-option>
                    <el-option key="2" label="湖南省" value="湖南省"></el-option>
                </el-select>-->
                <el-input v-model="query.name" placeholder="请输入IMEI" class="handle-input mr10"></el-input>
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">刷新</el-button>
                <!-- <el-button type="primary" icon="el-icon-search" @click="handleSearch">新增设备</el-button> -->
                <!-- <el-button type="primary" icon="el-icon-search" @click="handleSearch">更多操作</el-button> -->
            </div>
            <el-table
                :data="tableDatas"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                @selection-change="handleSelectionChange"
            >
                <el-table-column type="selection" width="55" align="center"></el-table-column>
                <el-table-column prop="ProjectName" label="项目名称" width="180" align="center"></el-table-column>
                <el-table-column prop="Creater" label="创建人" width="180" align="center"></el-table-column>
                <el-table-column prop="CreateTime" label="注册时间" width="180" align="center"></el-table-column>
                <el-table-column prop="summarized" label="描述"  align="center"></el-table-column>
                <el-table-column prop="enableValue" label="是否禁用" width="140" align="center"></el-table-column>

                <!-- <el-table-column label="状态" width="90" align="center">
                    <template slot-scope="scope">
                        <el-tag
                            v-if="scope.row.status == '正常'"
                            color="#08d97b"
                            type="success"
                        >{{ scope.row.status }}</el-tag>
                        <el-tag
                            v-if="scope.row.status == '故障'"
                            color="#ff8115"
                            type="success"
                        >{{ scope.row.status }}</el-tag>
                        <el-tag
                            v-if="scope.row.status == '报警'"
                            color="#e83c03"
                            type="success"
                        >{{ scope.row.status }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="二维码" width="90" align="center">
                    <template slot-scope="scope">
                        <div class="erCode" @click="erCodeBtn(scope.row)">查看</div>
                    </template>
                </el-table-column>
                <el-table-column prop="deviceType" width="120" label="设备类型" align="center"></el-table-column>
                <el-table-column prop="height" label="当前水位/米" width="110" align="center"></el-table-column>
                <el-table-column label="历史报警" width="120" align="center">
                    <template slot-scope="scope" class="blueCur">
                        <span class="blueCur" @click="historyAlarm(scope.$index, scope.row)">查看</span>
                    </template>
                </el-table-column>
                <el-table-column label="历史故障" width="120" align="center">
                    <template slot-scope="scope">
                        <span class="blueCur" @click="historyFault(scope.$index, scope.row)">查看</span>
                    </template>
                </el-table-column>
                <el-table-column prop="address" label="安装点位"></el-table-column>-->
                <!-- <el-table-column prop="tof" width="50" label="信号"></el-table-column> -->
                <el-table-column label="操作" width="240" align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="deviceDetail(scope.$index, scope.row)"
                        >详情</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            class="red"
                            @click="handleDelete(scope.$index, scope.row)"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.currentpage"
                    :page-size="query.pagesize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog title="编辑" :visible.sync="editVisible" width="30%">
            <el-form ref="form" :model="form" label-width="70px">
                <el-form-item label="用户名">
                    <el-input v-model="form.name"></el-input>
                </el-form-item>
                <el-form-item label="地址">
                    <el-input v-model="form.address"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 二维码弹出层 -->
        <el-dialog
            title="设备二维码"
            :visible.sync="erCodeVisible"
            width="600px"
            :before-close="handleClose"
        >
            <div id="qrCode" ref="qrCodeDiv" class="ercodeCov"></div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="handleClose">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { QueryProjectList } from '../../api/index';
// import QRCode from 'qrcodejs2';




export default {
    name: 'basetable',
    data() {
        return {
            erCodeVisible: false,
            tableDatas: [
                {
                    id: 1,
                    IMEI: 'SKCMXSD5ASDX52W5',
                    type: '智能井盖',
                    time: '2022-07-28 10:28:30',
                    blong: '西安圣豆电子',
                    address: '西安市雁塔区天...',
                    tof: '18'
                }
            ],
            query: {
                currentpage: 1,
                pagesize: 1
            },
            // tableData: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            pageTotal: 0,
            form: {},
            idx: -1,
            id: -1
        };
    },
    created() {
        // this.projectlist();

        // this.getDevice();
        // this.getData();
    },
    mounted() {
        // this.$nextTick(function() {
        //     this.bindQRCode();
        // });
    },
    methods: {

        // 获取项目列表
        async queryProjectList(){
            const result =await QueryProjectList({id:12})
        },


        // // 获取设备列表
        // async projectlist() {
        //     const DevicelistResult = await Projectlist(this.query);
        //     console.log(DevicelistResult);
        //     if (DevicelistResult.status !== 1) {
        //         this.$message.error('获取项目列表出错');
        //         return;
        //     }
        //     DevicelistResult.message.forEach((item,index) => {
        //         if(item.Enable){
        //           DevicelistResult.message[index].enableValue = '禁用'
        //         }else{
        //           DevicelistResult.message[index].enableValue = '启用'
        //         }
        //     });
        //     this.tableDatas = DevicelistResult.message;
        //     console.log(this.tableDatas);
        //     this.pageTotal = DevicelistResult.count;
        // },
        // // 分页导航
        // async handlePageChange(val) {
        //     this.query.currentpage = val
        //     this.devicelist();
        // },


        // // ---------------------------------
        // // 点击查看设备二维码
        // erCodeBtn(e) {
        //     this.erCodeVisible = true;
        //     this.$nextTick(function() {
        //         new QRCode(this.$refs.qrCodeDiv, {
        //             text: `设备ID:${e.id} 设备IMEI:${e.IMEI} 设备类型:${e.deviceType} 设备创建时间:${e.timer} 设备归属:${e.blong}
        //            `,
        //             width: 300,
        //             height: 300,
        //             colorDark: '#333333', //二维码颜色
        //             colorLight: '#ffffff', //二维码背景色
        //             correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
        //         });
        //     });
        // },
        // // 关闭二维码弹窗时清除二维码
        // handleClose() {
        //     const codeHtml = document.getElementById('qrCode');
        //     codeHtml.innerHTML = '';
        //     this.erCodeVisible = false;
        // },
        // // 生成二维码
        // // bindQRCode() {},
        // // 获取设备数据
        // // getDevice() {
        // //     this.tableDatas = this.$store.state.deviceNowData;
        // //     console.log(this.tableDatas);
        // //     this.pageTotal = this.$store.state.deviceNowData.length;
        // // },

        // // 进入设备详情
        // deviceDetail(e1, e2) {
        //     this.$router.push(`/DeviceDetail?id=${e2.id}`);
        // },
        // // 查看设备历史报警
        // historyAlarm(e1, e2) {
        //     this.$router.push(`/HistroyAlarm?id=${e2.id}`);
        // },
        // // 查看设备历史故障
        // historyFault(e1, e2) {
        //     this.$router.push(`/HistroyFault?id=${e2.id}`);
        // },
        // // 获取 easy-mock 的模拟数据
        // // getData() {
        // //     fetchData(this.query).then(res => {
        // //         console.log(res);
        // //         this.tableData = res.list;
        // //         this.pageTotal = res.pageTotal || 50;
        // //     });
        // // },
        // // 触发搜索按钮
        // handleSearch() {
        //     this.$set(this.query, 'pageIndex', 1);
        //     this.getData();
        // },
        // // 删除操作
        // handleDelete(index, row) {
        //     // 二次确认删除
        //     this.$confirm('确定要删除吗？', '提示', {
        //         type: 'warning'
        //     })
        //         .then(() => {
        //             this.$message.success('删除成功');
        //             this.tableData.splice(index, 1);
        //         })
        //         .catch(() => {});
        // },
        // // 多选操作
        // handleSelectionChange(val) {
        //     this.multipleSelection = val;
        // },
        // delAllSelection() {
        //     const length = this.multipleSelection.length;
        //     let str = '';
        //     this.delList = this.delList.concat(this.multipleSelection);
        //     for (let i = 0; i < length; i++) {
        //         str += this.multipleSelection[i].name + ' ';
        //     }
        //     this.$message.error(`删除了${str}`);
        //     this.multipleSelection = [];
        // },
        // // 编辑操作
        // handleEdit(index, row) {
        //     this.idx = index;
        //     this.form = row;
        //     this.editVisible = true;
        // },
        // // 保存编辑
        // saveEdit() {
        //     this.editVisible = false;
        //     this.$message.success(`修改第 ${this.idx + 1} 行成功`);
        //     this.$set(this.tableData, this.idx, this.form);
        // }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.erCode {
    color: #409eff;
    cursor: pointer;
}
.ercodeCov {
    display: flex;
    justify-content: center;
}
.el-tag.el-tag--success {
    color: #ffffff;
}
.blueCur {
    color: #409eff;
    cursor: pointer;
}
</style>
